import { Component, OnInit } from '@angular/core';
import { StoreService } from './../../../../services/store.service';
import { ApiService } from './../../../../services/api.service';
import { Profil } from './../../../../models/Profil';
import { CommandeService } from './../../../../services/commande.service';
import { SelectItem, Message, ConfirmationService, UIChart } from 'primeng/primeng';
import { CommandeBordereau } from 'src/app/models/CommandeBordereau';
import { CommandeDetail } from 'src/app/models/CommandeDetail';
import { Commande } from 'src/app/models/Commande';
import { ThrowStmt } from '@angular/compiler';
import { ClientsService } from 'src/app/services/reporting/clients.service';
import { LocaliteService } from 'src/app/services/reporting/localites.service';
import { CriteriaData } from 'src/app/models/CriteriaData';
import { ReportingVenteService } from 'src/app/services/reporting/reporting.vente.service';
import { DatePipe } from '@angular/common';
import { ExcelService } from 'src/app/services/Excel.service';

@Component({
  selector: 'app-vente-nafama',
  templateUrl: './vente-nafama.component.html',
  styleUrls: ['./vente-nafama.component.css']
})
export class VenteNafamaComponent implements OnInit {

  titre = 'Ventes - Nafama';
  itemId: any;
  msgs: Message[] = [];

  fr = {
    firstDayOfWeek: 0,
    monthNames: [
      'Janvier', 'Février', 'Mars',
      'Avril', 'Mai', 'Juin',
      'Juillet', 'Août', 'Septembre',
      'Octobre', 'Novembre', 'Décembre'
    ],
    monthNamesShort: ['Janv.', 'Févr.', 'Mars', 'Avr.', 'Mai', 'Juin', 'Juil.', 'Août', 'Sept.', 'Oct.', 'Nov.', 'Déc.'],
    dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
    dayNamesShort: ['Dim.', 'Lun.', 'Mar.', 'Mer.', 'Jeu.', 'Ven.', 'Sam.'],
    dayNamesMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S']
  };

  displaychargement: boolean;
  dataBar: any;
  dataPie: any;
  listeDataPie: any[] = [0, 0];
  listeDataBarRegion: any[] = [''];
  listeDataBarZone: any[] = [0];
  listeDataBarHorsZone: any[] = [0];

  listMsisdn: SelectItem[] = [];
  listLogin: SelectItem[] = [];
  listRegroupment: SelectItem[] = [];
  listLocalite: SelectItem[] = [];
  listLocalite2: SelectItem[] = [];
  listLocalite3: SelectItem[] = [];
  listLocalite4: SelectItem[] = [];

  selectedCodedz: string;
  selectedSousZone: string;
  selectedSecteur: string;
  selectedLocalitedd: string;
  selectedPdg: string;
  selectedMsisdn: string;
  selectedRegroupement: string;
  datedebut: any = new Date();
  datefin: any = new Date();

  itemsGlobal: any[] = [];
  itemsZone: any[] = [];
  itemsHorsZone: any[] = [];
  itemsRevendeurZone: any[] = [];
  itemsRevendeurGlobal: any[] = [];
  itemsRevendeurDefault: any[] = [];
  itemsRevendeurHorsZone: any[] = [];
  itemsTaux: any[] = [];
  itemsGlobalTaux: any;

  tailleListeGlobal = 0;
  montantTotal = 0;
  montantTotalZone = 0;
  montantTotalHorsZone = 0;
  taux = '';
  revendeur = '';

  displayRegroupementDZ: boolean = true;
  displayRegroupementSOUSZONE: boolean = false;
  displayRegroupementSECTEUR: boolean = false;
  displayRegroupementLOCALITE: boolean = false;

  constructor(private confirmationService: ConfirmationService,
    private commandeService: CommandeService,
    private datePipe: DatePipe,
    private localiteService: LocaliteService,
    private clientsService: ClientsService,
    private reportingVenteService: ReportingVenteService,
    private excelService: ExcelService,
    private store: StoreService) { }

  ngOnInit() {
    this.selectedRegroupement = 'SOUSZONE';
    this.loadSelectList();
    this.initChartBarre();
    this.initChartPie();
  }

  async recherche(chartPie: UIChart, chartBarre: UIChart) {
    if (this.selectedMsisdn === null || this.selectedMsisdn === undefined || this.selectedMsisdn === '') {
      //this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Veuillez selection un msisdn PDG ' });
      //return;
    }
    if (this.datedebut === null || this.datedebut === undefined) {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Veuillez selectionnez une date de debut !' });
      return;
    }
    if (this.datefin === null || this.datefin === undefined) {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Veuillez selectionnez une date de fin !' });
      return;
    }
    if (this.selectedRegroupement === null || this.selectedRegroupement === undefined || this.selectedRegroupement === '') {
      this.selectedRegroupement = 'SOUSZONE';
    }

    this.listeDataPie = [0, 0];
    this.listeDataBarRegion = [''];
    this.listeDataBarZone = [0];
    this.listeDataBarHorsZone = [0];

    this.itemsGlobal = [];
    this.itemsHorsZone = [];
    this.itemsZone = [];

    let criteria: CriteriaData = new CriteriaData();
    criteria.codedz = this.selectedCodedz;
    criteria.souszone = this.selectedSousZone;
    criteria.secteur = this.selectedSecteur;
    criteria.localitedd = this.selectedLocalitedd;
    criteria.pdg = this.selectedPdg;
    criteria.msisdn = this.selectedMsisdn;
    criteria.revendeur = this.revendeur;
    criteria.regroupement = this.selectedRegroupement;
    criteria.datedebut = this.localeDateString(this.datedebut);
    criteria.datefin = this.localeDateString(this.datefin);
    criteria.horzone = "";
    console.log(JSON.stringify(criteria));

    this.displaychargement = true;

    try {
      this.itemsGlobal = <any>await this.reportingVenteService.venteNafama(criteria).toPromise();
    } catch (error) {

    }
    //console.log('itemsGlobal: ', this.itemsGlobal);

    criteria.horzone = "N";
    try {
      //this.itemsHorsZone = <any>await this.reportingVenteService.venteNafama(criteria).toPromise();  
    } catch (error) {

    }
    //console.log('itemsHorsZone: ', this.itemsHorsZone);

    criteria.horzone = "Y";
    try {
      //this.itemsZone = <any>await this.reportingVenteService.venteNafama(criteria).toPromise();  
    } catch (error) {

    }
    //console.log('itemsZone: ', this.itemsZone);

    criteria.horzone = "N";
    try {
      //this.itemsRevendeurHorsZone = <any>await this.reportingVenteService.venteNafamaRevendeur(criteria).toPromise();  
    } catch (error) {

    }
    //console.log('itemsRevendeurHorsZone: ', this.itemsRevendeurHorsZone);

    criteria.horzone = "Y";
    try {
      //this.itemsRevendeurZone = <any>await this.reportingVenteService.venteNafamaRevendeur(criteria).toPromise();  
    } catch (error) {

    }
    //console.log('itemsRevendeurZone: ', this.itemsRevendeurZone);

    this.displaychargement = false;

    this.itemsHorsZone = [];
    this.itemsZone = [];
    if (this.itemsHorsZone === null || this.itemsHorsZone === undefined) {
      this.itemsHorsZone = [];
    }
    if (this.itemsZone === null || this.itemsZone === undefined) {
      this.itemsZone = [];
    }

    this.montantTotal = 0;
    this.montantTotalZone = 0;
    this.montantTotalHorsZone = 0;

    this.itemsGlobal.forEach(e => {
      this.montantTotal += Number(e.valeur);

      if (e.horszone === '0') {
        this.itemsZone.push(e);
      } else if (e.horszone === '1') {
        this.itemsHorsZone.push(e);
      }

    });

    this.itemsZone.forEach(e => {
      this.montantTotalZone += Number(e.valeur);
    });
    this.itemsZone.forEach(e => {
      this.listeDataBarRegion.push(e.region);
      this.listeDataBarZone.push(e.valeur);
    });
    this.itemsHorsZone.forEach(e => {
      this.listeDataBarHorsZone.push(e.valeur);
    });
    this.itemsHorsZone.forEach(e => {
      this.montantTotalHorsZone += Number(e.valeur);
    });
    this.tailleListeGlobal = this.itemsGlobal.length;
    this.taux = (this.montantTotalZone * 100 / this.montantTotal).toFixed(2) + '%';
    this.listeDataPie = [this.montantTotalZone, this.montantTotalHorsZone];


    this.printChartBarre(chartBarre);
    this.printChartPie(chartPie);

  }

  async rechercheRevendeurHorsZone() {
    if (this.selectedMsisdn === null || this.selectedMsisdn === undefined || this.selectedMsisdn === '') {
      //this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Veuillez selection un msisdn PDG ' });
      //return;
    }
    if (this.datedebut === null || this.datedebut === undefined) {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Veuillez selectionnez une date de debut !' });
      return;
    }
    if (this.datefin === null || this.datefin === undefined) {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Veuillez selectionnez une date de fin !' });
      return;
    }

    this.listeDataPie = [0, 0];
    this.listeDataBarRegion = [''];
    this.listeDataBarZone = [0];
    this.listeDataBarHorsZone = [0];

    let criteria: CriteriaData = new CriteriaData();
    criteria.codedz = this.selectedCodedz;
    criteria.souszone = this.selectedSousZone;
    criteria.secteur = this.selectedSecteur;
    criteria.localitedd = this.selectedLocalitedd;
    criteria.pdg = this.selectedPdg;
    criteria.msisdn = this.selectedMsisdn;
    criteria.revendeur = this.revendeur;
    criteria.regroupement = this.selectedRegroupement;
    criteria.datedebut = this.localeDateString(this.datedebut);
    criteria.datefin = this.localeDateString(this.datefin);
    criteria.horzone = "";
    console.log(JSON.stringify(criteria));

    this.displaychargement = true;

    criteria.horzone = "N";
    try {
      this.itemsRevendeurHorsZone = <any>await this.reportingVenteService.venteNafamaRevendeur(criteria).toPromise();
    } catch (error) {

    }
    //console.log('itemsRevendeurHorsZone: ', this.itemsRevendeurHorsZone);

    this.displaychargement = false;
  }




  async rechercheRevendeurZone() {
    if (this.selectedMsisdn === null || this.selectedMsisdn === undefined || this.selectedMsisdn === '') {
      //this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Veuillez selection un msisdn PDG ' });
      //return;
    }
    if (this.datedebut === null || this.datedebut === undefined) {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Veuillez selectionnez une date de debut !' });
      return;
    }
    if (this.datefin === null || this.datefin === undefined) {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Veuillez selectionnez une date de fin !' });
      return;
    }

    this.listeDataPie = [0, 0];
    this.listeDataBarRegion = [''];
    this.listeDataBarZone = [0];
    this.listeDataBarHorsZone = [0];

    let criteria: CriteriaData = new CriteriaData();
    criteria.codedz = this.selectedCodedz;
    criteria.souszone = this.selectedSousZone;
    criteria.secteur = this.selectedSecteur;
    criteria.localitedd = this.selectedLocalitedd;
    criteria.pdg = this.selectedPdg;
    criteria.msisdn = this.selectedMsisdn;
    criteria.revendeur = this.revendeur;
    criteria.regroupement = this.selectedRegroupement;
    criteria.datedebut = this.localeDateString(this.datedebut);
    criteria.datefin = this.localeDateString(this.datefin);
    criteria.horzone = "";
    console.log(JSON.stringify(criteria));

    this.displaychargement = true;

    criteria.horzone = "Y";
    try {
      this.itemsRevendeurZone = <any>await this.reportingVenteService.venteNafamaRevendeur(criteria).toPromise();
    } catch (error) {

    }
    //console.log('itemsRevendeurZone: ', this.itemsRevendeurZone);

    this.displaychargement = false;
  }


  async rechercheRevendeurGlobal() {
    if (this.selectedMsisdn === null || this.selectedMsisdn === undefined || this.selectedMsisdn === '') {
      //this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Veuillez selection un msisdn PDG ' });
      //return;
    }
    if (this.datedebut === null || this.datedebut === undefined) {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Veuillez selectionnez une date de debut !' });
      return;
    }
    if (this.datefin === null || this.datefin === undefined) {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Veuillez selectionnez une date de fin !' });
      return;
    }

    this.listeDataPie = [0, 0];
    this.listeDataBarRegion = [''];
    this.listeDataBarZone = [0];
    this.listeDataBarHorsZone = [0];

    let criteria: CriteriaData = new CriteriaData();
    criteria.codedz = this.selectedCodedz;
    criteria.souszone = this.selectedSousZone;
    criteria.secteur = this.selectedSecteur;
    criteria.localitedd = this.selectedLocalitedd;
    criteria.pdg = this.selectedPdg;
    criteria.msisdn = this.selectedMsisdn;
    criteria.revendeur = this.revendeur;
    criteria.regroupement = this.selectedRegroupement;
    criteria.datedebut = this.localeDateString(this.datedebut);
    criteria.datefin = this.localeDateString(this.datefin);
    criteria.horzone = "";
    console.log(JSON.stringify(criteria));

    this.displaychargement = true;
    
    try {
      this.itemsRevendeurGlobal = <any>await this.reportingVenteService.venteNafamaRevendeur(criteria).toPromise();
    } catch (error) {

    }
    //console.log('itemsRevendeurZone: ', this.itemsRevendeurZone);

    this.displaychargement = false;
  }


  async rechercheRevendeurDefault() {
    if (this.selectedMsisdn === null || this.selectedMsisdn === undefined || this.selectedMsisdn === '') {
      //this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Veuillez selection un msisdn PDG ' });
      //return;
    }
    if (this.datedebut === null || this.datedebut === undefined) {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Veuillez selectionnez une date de debut !' });
      return;
    }
    if (this.datefin === null || this.datefin === undefined) {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Veuillez selectionnez une date de fin !' });
      return;
    }

    this.listeDataPie = [0, 0];
    this.listeDataBarRegion = [''];
    this.listeDataBarZone = [0];
    this.listeDataBarHorsZone = [0];

    let criteria: CriteriaData = new CriteriaData();
    criteria.codedz = this.selectedCodedz;
    criteria.souszone = this.selectedSousZone;
    criteria.secteur = this.selectedSecteur;
    criteria.localitedd = this.selectedLocalitedd;
    criteria.pdg = this.selectedPdg;
    criteria.msisdn = this.selectedMsisdn;
    criteria.revendeur = this.revendeur;
    criteria.regroupement = this.selectedRegroupement;
    criteria.datedebut = this.localeDateString(this.datedebut);
    criteria.datefin = this.localeDateString(this.datefin);
    criteria.horzone = "";
    console.log(JSON.stringify(criteria));

    this.displaychargement = true;
    
    try {
      this.itemsRevendeurDefault = <any>await this.reportingVenteService.venteNafamaRevendeurDefault(criteria).toPromise();
    } catch (error) {

    }
    //console.log('itemsRevendeurZone: ', this.itemsRevendeurZone);

    this.displaychargement = false;
  }



  printChartBarre(chart: UIChart) {
    this.dataBar = {
      labels: this.listeDataBarRegion,
      datasets: [
        {
          label: 'Vente Zone',
          backgroundColor: '#ff7e33',
          borderColor: '#ff7e33',
          data: this.listeDataBarZone
        },
        {
          label: 'Vente Hors Zone',
          backgroundColor: '#42A5F5',
          borderColor: '#42A5F5',
          data: this.listeDataBarHorsZone
        }
      ]
    };
    setTimeout(() => {
      chart.ngOnDestroy();
      chart.initChart();
    }, 100);
  }

  printChartPie(chart: UIChart) {
    this.dataPie = {
      labels: ['ZONE', 'HORS_ZONE'],
      datasets: [
        {
          data: this.listeDataPie,
          backgroundColor: [
            "#00A056",
            "#FFCE56"
          ],
          hoverBackgroundColor: [
            "#00A056",
            "#FFCE56"
          ]
        }]
    };
    setTimeout(() => {
      chart.ngOnDestroy();
      chart.initChart();
    }, 100);
  }


  initChartBarre() {
    this.dataBar = {
      labels: [''],
      datasets: [
        {
          label: 'Vente Zone',
          backgroundColor: '#ff7e33',
          borderColor: '#ff7e33',
          data: [0]
        },
        {
          label: 'Vente Hors Zone',
          backgroundColor: '#42A5F5',
          borderColor: '#42A5F5',
          data: [0]
        }
      ]
    };
  }

  initChartPie() {
    this.dataPie = {
      labels: ['ZONE', 'HORS_ZONE'],
      datasets: [
        {
          data: this.listeDataPie,
          backgroundColor: [
            "#00A056",
            "#FFCE56"
          ],
          hoverBackgroundColor: [
            "#00A056",
            "#FFCE56"
          ]
        }]
    };
  }






  async loadSelectList() {

    this.displayRegroupementDZ = false;
    this.displayRegroupementSOUSZONE = true;
    this.displayRegroupementSECTEUR = false;
    this.displayRegroupementLOCALITE = false;

    this.listLogin = [];
    if (this.store.isUserPartenaire) {
      this.listLogin.push({ label: this.store.currentNomPDG, value: this.store.currentNomPDG });
      this.selectedPdg = this.store.currentNomPDG;
    } else {
      this.listLogin.push({ label: 'PDG...', value: null });
      try {
        let dataRetourPdg = <any>await this.clientsService.findAgents().toPromise();
        for (let el of dataRetourPdg) {
          this.listLogin.push({ label: el.login, value: el.login });
        }
      } catch (error) { }
    }

    this.listMsisdn = [];
    this.listMsisdn.push({ label: 'Msisdn...', value: null });

    this.listRegroupment = [];
    this.listRegroupment.push({ label: 'Niveau...', value: null });
    this.listRegroupment.push({ label: 'DZ', value: 'DZ' });
    this.listRegroupment.push({ label: 'Sous Zone', value: 'SOUSZONE' });
    this.listRegroupment.push({ label: 'Secteur', value: 'SECTEUR' });
    this.listRegroupment.push({ label: 'Code localité', value: 'LOCALITE' });

    try {
      this.listLocalite = [];
      this.listLocalite.push({ label: 'DZ...', value: null });
      let dataRetour = <any>await this.localiteService.findCodedz().toPromise();
      for (let el of dataRetour) {
        this.listLocalite.push({ label: el.codedz, value: el.codedz });
      }
    } catch (error) { }

    this.listLocalite2 = [];
    this.listLocalite2.push({ label: 'Sous zone...', value: null });
    this.listLocalite3 = [];
    this.listLocalite3.push({ label: 'Secteur...', value: null });
    this.listLocalite4 = [];
    this.listLocalite4.push({ label: 'Localite...', value: null });

  }

  async onChangeLocalite(event) {
    this.listLocalite2 = [];
    this.listLocalite2.push({ label: 'Sous zone...', value: null });
    let dataRet = <any>await this.localiteService.findCodeSousZone(event).toPromise();
    for (let el of dataRet) {
      this.listLocalite2.push({ label: el.codeSousZone, value: el.codeSousZone });
    }
    this.listLocalite3 = [];
    this.listLocalite3.push({ label: 'Secteur...', value: null });
    this.listLocalite4 = [];
    this.listLocalite4.push({ label: 'Localite...', value: null });
  }
  async onChangeLocalite2(event) {
    this.listLocalite3 = [];
    this.listLocalite3.push({ label: 'Secteur...', value: null });
    let dataRet = <any>await this.localiteService.findCodeSecteur(event).toPromise();
    for (let el of dataRet) {
      this.listLocalite3.push({ label: el.codeSecteur, value: el.codeSecteur });
    }
    this.listLocalite4 = [];
    this.listLocalite4.push({ label: 'Localite...', value: null });
  }

  async onChangeLocalite3(event) {
    this.listLocalite4 = [];
    this.listLocalite4.push({ label: 'Localite...', value: null });
    let dataRet = <any>await this.localiteService.findCodeLocalitedd(event).toPromise();
    for (let el of dataRet) {
      this.listLocalite4.push({ label: el.codeLocalitedd + ' - ' + el.localitedd, value: el.localitedd });
    }
  }

  async onChangePDG(event) {
    this.listMsisdn = [];
    this.listMsisdn.push({ label: 'Msisdn...', value: null });
    let dataRet = <any>await this.clientsService.findByLogin(event).toPromise();
    for (let el of dataRet) {
      this.listMsisdn.push({ label: el.telephone, value: el.telephone });
    }
  }

  async onChangeRegroupement(event) {
    console.log("event=======" + event);
    if (event === 'SOUSZONE') {
      this.displayRegroupementDZ = false;
      this.displayRegroupementSOUSZONE = true;
      this.displayRegroupementSECTEUR = false;
      this.displayRegroupementLOCALITE = false;
    } else if (event === 'SECTEUR') {
      this.displayRegroupementDZ = false;
      this.displayRegroupementSOUSZONE = false;
      this.displayRegroupementSECTEUR = true;
      this.displayRegroupementLOCALITE = false;
    } else if (event === 'LOCALITE') {
      this.displayRegroupementDZ = false;
      this.displayRegroupementSOUSZONE = false;
      this.displayRegroupementSECTEUR = false;
      this.displayRegroupementLOCALITE = true;
    } else {
      this.displayRegroupementDZ = false;
      this.displayRegroupementSOUSZONE = true;
      this.displayRegroupementSECTEUR = false;
      this.displayRegroupementLOCALITE = false;
    }
  }


  localeDateString(val: any): any {
    if (val === null || val === undefined) {
      return null;
    }
    if (typeof val === 'string') {
      return val;
    } else {
      return this.datePipe.transform(val, "dd/MM/yyyy");
    }
  }

  async exporter() {
    if (this.itemsGlobal === null || this.itemsGlobal === undefined) {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Aucune données trouvées !' });
      return;
    }
    if (this.itemsGlobal.length <= 0) {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Aucune données trouvées !' });
      return;
    }
    let listExportXLSX = [];
    const headers = [{name: 'PDG', key: 'pdg', display: true}, {name: 'REGION', key: 'zone',  display: true},  
    {name: 'SOUS_ZONE', key: 'souszone',  display: this.displayRegroupementSOUSZONE || (this.displayRegroupementSECTEUR || this.displayRegroupementLOCALITE)}, 
    {name: 'SECTEUR', key: 'secteur',  display: this.displayRegroupementSECTEUR || this.displayRegroupementSOUSZONE}, {name: 'LOCALITE', key:  'localitedd',  display: this.displayRegroupementLOCALITE}, 
    {name: 'MONTANT', key: 'valeur',  display: true}];

    listExportXLSX = [...this.itemsGlobal.map(entry => {
      const ret  = {};
      for(const h of headers) {
        if(h.display) {
          ret[h.name] = entry[h.key];
        }
      }
      return ret;
      // if (this.displayRegroupementDZ) {
      //   return {
      //     "PDG": entry.pdg,
      //     "REGION": entry.zone,
      //     "MONTANT": entry.valeur
      //   }
      // } else if (this.displayRegroupementSOUSZONE) {
      //   return {
      //     "PDG": entry.pdg,
      //     "REGION": entry.zone,
      //     "SOUS_ZONE": entry.souszone,
      //     "MONTANT": entry.valeur
      //   }
      // } else if (this.displayRegroupementSECTEUR) {
      //   return {
      //     "PDG": entry.pdg,
      //     "REGION": entry.zone,
      //     "SOUS_ZONE": entry.souszone,
      //     "SECTEUR": entry.secteur,
      //     "MONTANT": entry.valeur
      //   }
      // } else {
      //   return {
      //     "PDG": entry.pdg,
      //     "REGION": entry.zone,
      //     "SOUS_ZONE": entry.souszone,
      //     "SECTEUR": entry.secteur,
      //     "LOCALITE": entry.localitedd,
      //     "MONTANT": entry.valeur
      //   }
      // }
    })
    ];
    this.excelService.exportAsExcelFile(listExportXLSX, 'EXPORT');
    this.msgs = []; this.msgs.push({ severity: 'info', summary: 'Confirmation', detail: 'Export effectuée, ' + this.itemsGlobal.length + ' Ligne(s) trouvée(s)' });
  }

  async exporterZone() {
    if (this.itemsZone === null || this.itemsZone === undefined) {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Aucune données trouvées !' });
      return;
    }
    if (this.itemsZone.length <= 0) {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Aucune données trouvées !' });
      return;
    }
    let listExportXLSX = [];
    listExportXLSX = [...this.itemsZone.map(entry => {
        return {
          "PDG": entry.pdg,
          "REGION": this.aficherZone(entry.region),
          "MONTANT": entry.valeur
        }
    })
    ];
    this.excelService.exportAsExcelFile(listExportXLSX, 'EXPORT');
    this.msgs = []; this.msgs.push({ severity: 'info', summary: 'Confirmation', detail: 'Export effectuée, ' + this.itemsZone.length + ' Ligne(s) trouvée(s)' });
  }
  async exporterHorsZone() {
    if (this.itemsHorsZone === null || this.itemsHorsZone === undefined) {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Aucune données trouvées !' });
      return;
    }
    if (this.itemsHorsZone.length <= 0) {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Aucune données trouvées !' });
      return;
    }
    let listExportXLSX = [];
    listExportXLSX = [...this.itemsHorsZone.map(entry => {
        return {
          "PDG": entry.pdg,
          "REGION": this.aficherZone(entry.region),
          "MONTANT": entry.valeur
        }
    })
    ];
    this.excelService.exportAsExcelFile(listExportXLSX, 'EXPORT');
    this.msgs = []; this.msgs.push({ severity: 'info', summary: 'Confirmation', detail: 'Export effectuée, ' + this.itemsHorsZone.length + ' Ligne(s) trouvée(s)' });
  }
  async exporterGlobalRevendeur() {
    if (this.itemsRevendeurGlobal === null || this.itemsRevendeurGlobal === undefined) {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Aucune données trouvées !' });
      return;
    }
    if (this.itemsRevendeurGlobal.length <= 0) {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Aucune données trouvées !' });
      return;
    }
    let listExportXLSX = [];
    listExportXLSX = [...this.itemsRevendeurGlobal.map(entry => {
        return {
          "PDG": entry.pdg,
          "REGION": this.aficherZone(entry.region),
          "MONTANT": entry.valeur,
          "REVENDEUR": entry.revendeur
        }
    })
    ];
    this.excelService.exportAsExcelFile(listExportXLSX, 'EXPORT');
    this.msgs = []; this.msgs.push({ severity: 'info', summary: 'Confirmation', detail: 'Export effectuée, ' + this.itemsRevendeurZone.length + ' Ligne(s) trouvée(s)' });
  }

  async exporterDefaultRevendeur() {
    if (this.itemsRevendeurDefault === null || this.itemsRevendeurDefault === undefined) {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Aucune données trouvées !' });
      return;
    }
    if (this.itemsRevendeurDefault.length <= 0) {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Aucune données trouvées !' });
      return;
    }
    let listExportXLSX = [];
    listExportXLSX = [...this.itemsRevendeurDefault.map(entry => {
        return {
          "PDG": entry.pdg,
          "ZONE": this.aficherZone(entry.region),
          "MONTANT": entry.valeur,
          "REVENDEUR": entry.revendeur,
          "NUMERO PDG": entry.msisdnpdg
        }
    })
    ];
    this.excelService.exportAsExcelFile(listExportXLSX, 'EXPORT');
    this.msgs = []; this.msgs.push({ severity: 'info', summary: 'Confirmation', detail: 'Export effectuée, ' + this.itemsRevendeurZone.length + ' Ligne(s) trouvée(s)' });
  }

  async exporterZoneRevendeur() {
    if (this.itemsRevendeurZone === null || this.itemsRevendeurZone === undefined) {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Aucune données trouvées !' });
      return;
    }
    if (this.itemsRevendeurZone.length <= 0) {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Aucune données trouvées !' });
      return;
    }
    let listExportXLSX = [];
    listExportXLSX = [...this.itemsRevendeurZone.map(entry => {
        return {
          "PDG": entry.pdg,
          "REGION": this.aficherZone(entry.region),
          "MONTANT": entry.valeur,
          "REVENDEUR": entry.revendeur
        }
    })
    ];
    this.excelService.exportAsExcelFile(listExportXLSX, 'EXPORT');
    this.msgs = []; this.msgs.push({ severity: 'info', summary: 'Confirmation', detail: 'Export effectuée, ' + this.itemsRevendeurZone.length + ' Ligne(s) trouvée(s)' });
  }
  async exporterHorsZoneRevendeur() {
    if (this.itemsRevendeurHorsZone === null || this.itemsRevendeurHorsZone === undefined) {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Aucune données trouvées !' });
      return;
    }
    if (this.itemsRevendeurHorsZone.length <= 0) {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Aucune données trouvées !' });
      return;
    }
    let listExportXLSX = [];
    listExportXLSX = [...this.itemsRevendeurHorsZone.map(entry => {
        return {
          "PDG": entry.pdg,
          "REGION": this.aficherZone(entry.region),
          "MONTANT": entry.valeur,
          "REVENDEUR": entry.revendeur
        }
    })
    ];
    this.excelService.exportAsExcelFile(listExportXLSX, 'EXPORT');
    this.msgs = []; this.msgs.push({ severity: 'info', summary: 'Confirmation', detail: 'Export effectuée, ' + this.itemsRevendeurHorsZone.length + ' Ligne(s) trouvée(s)' });
  }

  aficherZone(val) {
    if (val === '' || val === null || val === undefined) {
      return "NON LOCALISE";
    }
    return val;
  }

}


